import React, { useEffect, useState } from 'react';
import { Button, Paper, Tab, Tabs } from '@material-ui/core';

import { logisticsApi as api } from 'api/logistics';
import { DataTable, TabPanel } from 'shared';

import { ZipMapResultDetails } from './zipMapResultDetails';

function ZipMapResults() {
    const [selectedTab, setSelectedTab] = useState('0');
    const handleChange = (event, value) => {
        setSelectedTab(value);
    };

    return (
        <Paper>
            <Tabs onChange={handleChange} value={selectedTab} indicatorColor="primary" textColor="primary" centered>
                <Tab label="Zip Map Uploads" value="0" />
                <Tab label="Reassignments" value="1" />
            </Tabs>
            <TabPanel selectedTab={selectedTab} index="0">
                <ZipMapUploads />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="1">
                <ZipMapReassignments />
            </TabPanel>
        </Paper>
    );
}

function ZipMapUploads() {
    const [notification, setNotification] = useState({ text: '', level: '' });
    const [zipMapResults, setZipMapResults] = useState([]);

    const getZipMapResults = async () => {
        const res = await api.getZipMapResults();
        if (!res.status) {
            setNotification({ text: 'Failed to get zip map results', level: 'error' });
            return;
        }
        setZipMapResults(res.data.rows);
    };

    const columns = [
        { accessor: 'id', Header: 'ID' },
        { accessor: 'status', Header: 'Status' },
        { accessor: 'deliveryDay', Header: 'Delivery Day' },
        {
            Header: 'Optimal File',
            Cell: ({ row }) => (
                <Button
                    id={`OptimalFile_Download_${row.id}`}
                    onClick={() => {
                        api.getZipMapFile(
                            row.original.id,
                            'optimal',
                            row.original.timestamp.date,
                            row.original.deliveryDay,
                        );
                    }}
                >
                    Download
                </Button>
            ),
        },
        {
            Header: 'Backup File',
            Cell: ({ row }) => (
                <Button
                    id={`BackupFile_Download_${row.id}`}
                    onClick={() => {
                        api.getZipMapFile(
                            row.original.id,
                            'backup',
                            row.original.timestamp.date,
                            row.original.deliveryDay,
                        );
                    }}
                >
                    Download
                </Button>
            ),
        },
        { accessor: 'notes', Header: 'Notes' },
        { accessor: 'authUser', Header: 'Auth User' },
        { accessor: 'timestamp.date', Header: 'Timestamp' },
        { accessor: 'fbmPartnerName', Header: 'FBM Partner' },

        // {Header: "Revert", Cell: ({row}) => {
        //     return <Button>REVERT</Button>
        // }}
    ];

    useEffect(() => {
        getZipMapResults();
    }, []);

    return (
        <Paper>
            <DataTable columns={columns} data={zipMapResults} expandable ExpansionComponent={<ZipMapResultDetails />} />
        </Paper>
    );
}

function ZipMapReassignments() {
    const [rows, setRows] = useState([]);

    const getZipMapReassignmentResults = async () => {
        const res = await api.getZipMapReassignmentResults();
        if (!res.status) {
            setRows([]);
        }
        setRows(res.data.rows);
    };

    useEffect(() => {
        getZipMapReassignmentResults();
    }, []);

    const columns = [
        { accessor: 'id', Header: 'ID' },
        { accessor: 'status', Header: 'Status' },
        { accessor: 'deliveryDay', Header: 'Delivery Day' },
        {
            Header: '# Reassigned',
            Cell: ({ row }) => (
                <div>
                    <Button
                        disabled={row.original.reassignedSubs === 0}
                        onClick={() => {
                            api.getReassignmentFile(row.original.id, 'reassignedSubs');
                        }}
                    >
                        {row.original.reassignedSubs}
                    </Button>
                </div>
            ),
        },
        {
            Header: '# No Alternate',
            Cell: ({ row }) => (
                <div>
                    <Button
                        disabled={row.original.noAlternateSubs === 0}
                        onClick={() => {
                            api.getReassignmentFile(row.original.id, 'noAlternateSubs');
                        }}
                    >
                        {row.original.noAlternateSubs}
                    </Button>
                </div>
            ),
        },
        {
            Header: '# Alternate At Capacity',
            Cell: ({ row }) => (
                <div>
                    <Button
                        disabled={row.original.alternateAtCapacitySubs === 0}
                        onClick={() => {
                            api.getReassignmentFile(row.original.id, 'alternateAtCapacitySubs');
                        }}
                    >
                        {row.original.alternateAtCapacitySubs}
                    </Button>
                </div>
            ),
        },
        { accessor: 'authUser', Header: 'Auth User' },
        { accessor: 'timestamp.date', Header: 'Timestamp' },
    ];

    return (
        <Paper>
            <DataTable columns={columns} data={rows} />
        </Paper>
    );
}

export { ZipMapResults };
